import css from './index.module.scss';
import A from './components/A';
import IndexDynamic from './indexDynamic';

export default function CorporateSocialResponsibility_PC() {
    return (
        <div className={`csr ${css.csr}`}>
            <A />
            <IndexDynamic />
        </div>
    );
}
